import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import wtyReportApi from "../../services/warrantyReportAxios";

const initialState = {
    selectedProductId: "",
    customerHistory: [],
    loading: false,
    error: null
}

export const getCustomerHistoryForMachine = createAsyncThunk(
    "customerHistory/getCustomerHistoryForMachine",
    /*async ({prodId}) => {*/
        async ({pin}) => {
        const customerHistoryUrl = "/customer/customerHistoryFromCDP";
        const params = {
            pin: pin
        }
        try {
            const response = await wtyReportApi.get(customerHistoryUrl, params);
            if (response.status !== 200) {
                new Error("Calling api to get Customer History failed.");
            }
            return await response.data;
        } catch (error) {
            return error;
        }
    }
)

const customerHistorySlice = createSlice({
    name: "customerHistory",
    initialState,
    reducers: {
        setSelectedProdId: (state, action) => {
            state.selectedProductId = action.payload;
        },
        resetCustomerHistory: () => initialState
    },
    extraReducers: builder => {
        builder
            .addCase(getCustomerHistoryForMachine.pending, state => {
                state.loading = true;
                state.customerHistory = [];
            })
            .addCase(getCustomerHistoryForMachine.rejected, (state, action) => {
                state.loading = false;
                state.customerHistory = [];
                state.error = action.payload;
            })
            .addCase(getCustomerHistoryForMachine.fulfilled, (state, action) => {
                state.loading = false;
                state.customerHistory = action.payload;
                state.error = null;
            })
    }
})

export const {resetCustomerHistory} = customerHistorySlice.actions;

export const customerHistory = state => state.customerHistory.customerHistory;
export const custHistoryLoading = state => state.customerHistory.loading;
export const custHistoryError = state => state.customerHistory.error;
export const custHistorySelProduct = state => state.customerHistory.selectedProductId;

export default customerHistorySlice.reducer;